<template>
  <div class="shop-container" v-loading="loading">
    <swiper-small :list="bannerArr" />

    <div class="container bgw">
      <div class="filter-box">
        <div class="filter-list-wrap" style="border-bottom: 0">
          <div class="filter-list-head">{{ $t("type") }}:</div>
          <div class="filter-list">
            <div class="filter-item" :class="{ active: checkId == '' }" @click="clickType()">
              {{ $t("all") }}
            </div>
            <div class="filter-item" :class="{ active: checkId == item.id }" v-for="item in typelist" :key="item.id" @click="clickType(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="class-list" v-if="examList.length > 0">
      <div class="class-item-wrap">
        <div class="class-item" v-for="item in examList" :key="item.id" @click="detail(item)">
          <!-- <img :src="item.cover" alt="" > -->
          <div
            class="videp-cover"
            :style="{
              backgroundImage: `url(${item.cover})`,
              backgroundSize: 'cover',
            }"
          ></div>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="pagination-wrap" v-if="totalPage > 0">
      <pagination :totalPage="totalPage" :limit="10" @changePage="changePage" />
    </div>
  </div>
</template>

<script>
import SwiperSmall from "@/components/common/SwiperSmall.vue";
import Pagination from "@/components/common/Pagination.vue";
export default {
  components: {
    SwiperSmall,
    Pagination,
  },
  data() {
    return {
      bannerArr: [],
      examList: [], // 考试列表

      form1: {
        page: 1,
        limit: 12,
      },
      checkId: "",
      loading: false,
      typelist: [],
      totalPage: 0,
    };
  },
  mounted() {
    this.getBanner();
    this.list();
  },
  methods: {
    // 获取轮播图s
    getBanner() {
      this.$api
        .slider({
          code: "pc_home_slide",
        })
        .then((res) => {
          if (res.status) {
            this.bannerArr = res.data.list;
          }
        });
    },

    list(id) {
      if (id) {
        this.form1.type_id = id;
      }
      this.loading = true;
      this.$api.planList(this.form1).then((res) => {
        this.examList = res.data.list;
        this.typelist = res.data.typelist;
        this.totalPage = Math.ceil(res.data.count / this.form1.limit);
        this.loading = false;
      });
    },
    // 类型点击
    clickType(val) {
      this.form1.type_id = val ? val.id : "";
      this.checkId = val ? val.id : "";
      this.page = 1;
      this.list();
    },
    detail(item) {
      this.$router.push({
        name: "examitem",
        params: {
          id: item.id
        },
      });
    },
    changePage(v) {
      this.form1.page = v;
      this.list();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.pagination-wrap {
  float: left;
  margin-bottom: 20px;
  width: 100%;
  .page-box {
    float: right;
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.mini-menus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .mini-menus-item {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    width: 380px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(242, 241, 241, 1);
    padding: 21px 23px;
    .mini-menus-item-title {
      font-size: 14px;
      color: rgba(49, 44, 44, 1);
      text-align: left;
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      img {
        width: 18px;
        height: 18px;
        margin-right: 9px;
      }
    }
    .right-logo {
      width: 16px;
      height: 16px;
    }
  }
}
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
  .class-item-gameList {
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 13px;
    padding: 17px 20px 30px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    border: 1px solid rgba(204, 202, 202, 1);
    background-color: white;
    &:hover {
      //   box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
      box-shadow: 0px 2px 10px rgba(49, 44, 44, 0.2);
      border: 1px solid transparent;
    }
    &:first-child {
      margin-left: 0;
    }
    &:nth-child(6n) {
      margin-left: 0;
    }
    .videp-cover {
      width: 254px;
      height: 200px;
      margin-bottom: 15px;
      // border-radius: 10px;
    }
    .text {
      width: 254px;
      height: 20px;
      opacity: 1;
      /** 文本1 */
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 19.21px;
      color: rgba(49, 44, 44, 1);
      text-align: left;
      vertical-align: top;
      margin-bottom: 12px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      //   @include no-wrap-line(2);
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn-red {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: rgba(231, 68, 47, 1);
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn-gray {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: #c4c4c4;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn-blueOson {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: #192742;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn {
        width: 60px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: rgba(49, 44, 44, 1);
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(204, 202, 202, 1);
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        // margin-right: 10px;
      }
    }
  }
}
.container {
  background: #fff;
  padding: 4px 18px;
  margin: 20px 0;
  .filter-box {
    margin: 0 auto;
    font-size: 14px;
    .filter-list-wrap {
      position: relative;
      padding-left: 72px;
      transition: height 0.25s linear;
      border-bottom: 1px dashed $border;
      &.open {
        .filter-list {
          height: 120px;
        }
      }
      .filter-list-head {
        width: 72px;
        position: absolute;
        left: 0;
        top: 14px;
        color: #b0b0b0;
      }
      .filter-list {
        display: flex;
        flex-flow: row wrap;
        .filter-item {
          width: 150px;
          height: 20px;
          line-height: 20px;
          padding: 12px 0;
          cursor: pointer;
          &.active {
            color: $theme-color;
          }
        }
      }
      .more {
        position: absolute;
        right: 0;
        top: 8px;
        height: 24px;
        line-height: 24px;
        color: #757575;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: $theme-color;
        }
        .icon {
          display: inline-block;
          transition: all 0.2s;
          &.top {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}
</style>
